/**
 * Generate a unique, obfuscated string ID using user email and timestamp.
 * Returns a hex string from SHA-256 hash.
 */
export async function generateObfuscatedId(email: string, timestamp: string): Promise<string> {
  const data = new TextEncoder().encode(email + ':' + timestamp);
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}
